import { __assign, __awaiter, __generator } from "tslib";
import React, { useEffect, useState } from 'react';
import { Authenticator, useAuthenticator, } from '@aws-amplify/ui-react';
import { formFields } from './form-fields';
import { auth } from './auth';
import { useCustomSlots } from './use-custom-slots';
import { useServices } from './use-services';
import './styles.css';
export function OvLogin(props) {
    return (React.createElement(Authenticator.Provider, null,
        React.createElement(LoginContent, __assign({}, props))));
}
var signUpAttributes = [
    'given_name',
    'family_name',
    'email',
];
function LoginContent(props) {
    var _a = useAuthenticator(function (context) { return [
        context.authStatus,
    ]; }), authStatus = _a.authStatus, toSignIn = _a.toSignIn;
    var _b = useState(false), authInitialized = _b[0], setAuthInitialized = _b[1];
    useEffect(function () {
        function execute() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, auth.init()];
                        case 1:
                            if (_a.sent()) {
                                setAuthInitialized(true);
                            }
                            else {
                                auth.signOut();
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (authStatus === 'authenticated') {
            execute();
        }
        else {
            setAuthInitialized(false);
        }
    }, [authStatus]);
    var App = props.app;
    return (React.createElement(React.Fragment, null,
        React.createElement(Authenticator, { loginMechanisms: ['email'], hideSignUp: !props.withSignUp, formFields: formFields, signUpAttributes: signUpAttributes, components: useCustomSlots(props.logo), services: useServices(toSignIn) }, authInitialized ? React.createElement(App, null) : null)));
}
